// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2epij","content":"styles_content__1gYLn","tableWrap":"styles_tableWrap__2zjcd"};